import useExternalJS from './useExternalJS';
import useListenMessage from './useListenMessage';
import useTheme from './useTheme';
import useTrackingElements from './useTrackingElements';
import useGetUserServlet from './user/useGetUserServlet';

const propTypes = {};

const GlobalHooks = () => {
  //! Execute when app start
  useListenMessage();
  useExternalJS();
  useTheme();
  useTrackingElements();
  useGetUserServlet();

  return null;
};

GlobalHooks.propTypes = propTypes;
export default GlobalHooks;
